type ChevronUpIconProps = {
  size?: number
}

export function ChevronUpIcon({ size = 24 }: ChevronUpIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M16.4698 13.5303C16.7627 13.8232 17.2374 13.8232 17.5303 13.5303C17.8232 13.2374 17.8232 12.7626 17.5303 12.4697L10.5303 5.46973C10.2374 5.17685 9.76265 5.17689 9.46975 5.46973L2.46973 12.4697C2.17684 12.7626 2.17684 13.2374 2.46973 13.5303C2.76263 13.8232 3.23739 13.8232 3.53028 13.5303L10 7.06055L16.4698 13.5303Z" fill="currentColor" />
    </svg>
  )
}
